"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "varano-de-melegari": {
    "36366420": [{
      "hkey": "dfe46838",
      "slug": "varano-de-melegari",
      "name": "Varano de' Melegari",
      "primary": true,
      "skipSearch": false
    }],
    "montesalso": [{
      "hkey": "dfe46838",
      "slug": "varano-de-melegari",
      "name": "Varano de' Melegari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9009d01a": [{
      "hkey": "dfe46838",
      "slug": "varano-de-melegari",
      "name": "Varano de' Melegari",
      "primary": true,
      "skipSearch": false
    }],
    "riviano": [{
      "hkey": "dfe46838",
      "slug": "varano-de-melegari",
      "name": "Varano de' Melegari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;